import * as moment from "moment";
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../../components/Component";
import DatePicker from "../../../components/range-date-picker/RangeDatePicker";
import Table from "../../../components/react-table/Table";
import { DELETE, GET } from "../../../helper/api";
import { getToken } from "../../../helper/auth";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { BILL_STATUS, BILL_TYPE, INGREDIENT_GROUP, LOCATION } from "../../../utils/Utils";
import { ModalPnBillVAT } from "./ModalPnBillVAT";

const BILL_TYPE_OPTIONS = Object.keys(BILL_TYPE).map((c) => ({
  label: BILL_TYPE[c],
  value: c,
}));


const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const LOCATION_OPTIONS = Object.keys(LOCATION).map((c) => ({
  label: LOCATION[c],
  value: c,
}));

const PnBillManager = () => {
  const clearPagi = useRef();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    addReport: false,
    isDelete: false,
  });

  const history = useHistory();
  const location = useLocation();
  const searchParams = queryString.parse(location.search, { arrayFormat: 'bracket' })
  const [loading, setLoading] = useState(false);
  const [deleteItem, setDeleteItem] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [selectedBillIds, setSelectedBillIds] = useState([]);
  const [showModalVAT, setShowModalVAT] = useState(false);
  const [rangeDate, setRangeDate] = useState({
    fromDate: moment(searchParams?.fromDate || undefined).startOf('days').toDate(),
    toDate: moment(searchParams?.toDate || undefined).endOf('days').toDate(),
  });
  const [filter, setFilter] = useState({
    customerId: searchParams?.customerId || undefined,
    customerDirection: searchParams?.customerDirection || undefined,
    type: searchParams?.type || undefined,
    ingredientId: searchParams?.ingredientId || [],
    status: searchParams?.status || undefined,

    truckId: searchParams?.truckId || undefined,
    driverId: searchParams?.driverId || undefined,
    fromLocation: searchParams?.fromLocation || undefined,
    toLocation: searchParams?.toLocation || undefined,
    location: searchParams?.location || undefined,
    note: searchParams?.note || undefined,
  });
  const [customerOptions, setCustomerOptions] = useState([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const [fromLocationOptions, setFromLocationOptions] = useState([]);
  const [toLocationOptions, setToLocationOptions] = useState([]);

  // Lấy customerId của nhóm đang chọn (theo bill đầu tiên được tick)
  const selectedCustomerId = selectedBillIds.length > 0
    ? data.find(item => item.id === selectedBillIds[0])?.customerId
    : null;

  // Chỉ hiện checkbox cho bill APPROVED, chưa VAT, và cùng customerId với nhóm đang chọn
  const availableBillIds = data
    .filter(item =>
      item.status === "APPROVED" &&
      !item.isCreatedVatBill &&
      (selectedCustomerId == null || item.customerId === selectedCustomerId)
    )
    .map(item => item.id);

  const isSelectedAll =
    availableBillIds.length > 0 &&
    availableBillIds.every(id => selectedBillIds.includes(id));

  const toggleSelectBill = (billId) => {
    setSelectedBillIds(prev =>
      prev.includes(billId) ? prev.filter(id => id !== billId) : [...prev, billId]
    );
  };

  const colTable = [
    {
      id: "select",
      Header: () => (
        <div
          className="d-flex justify-content-center align-items-center cursor-pointer"
          style={{
            width: 13,
            height: 13,
            ...(isSelectedAll || selectedBillIds.length
              ? { backgroundColor: "#0275ff" }
              : { border: "1px solid #767676" }),
          }}
          onClick={() =>
            isSelectedAll
              ? setSelectedBillIds([])
              : setSelectedBillIds(availableBillIds)
          }
        >
          <span style={{ color: "white", fontSize: 12 }}>
            {isSelectedAll ? "✓" : selectedBillIds.length > 0 ? "-" : ""}
          </span>
        </div>
      ),
      accessor: (item) => {
        const isEligible =
          item.status === "APPROVED" &&
          !item.isCreatedVatBill &&
          (selectedCustomerId == null || item.customerId === selectedCustomerId);
        if (!isEligible) return null;
        if (item.customer?.type !== 'OUT') {
          return null;
        }
        return (
          <Input
            type="checkbox"
            className="ml-0"
            checked={selectedBillIds.includes(item.id)}
            onClick={() => toggleSelectBill(item.id)}
          />
        );
      },
    },
    {
      Header: "Mã",
      accessor: "id",
    },

    {
      Header: "Khách hàng",
      accessor: (item) => item?.customer?.name || "",
    },

    {
      Header: "Loại",
      accessor: (item) => item?.typeName,
    },
    {
      Header: "Địa điểm",
      accessor: (item) => item?.locationName,
    },
    {
      Header: "Hàng hoá",
      accessor: (item) => item?.ingredientVATName || "",
    },
    {
      Header: "N/X HH",
      accessor: (item) => item?.customerDirectionName || "",
    },
    {
      Header: "Biển số xe",
      accessor: (item) => item?.truckId || "",
    },
    {
      Header: "Tài xế",
      accessor: (item) => item?.driver?.name || "",
    },
    {
      Header: "Điểm A",
      accessor: (item) => item?.fromLocationName,
    },
    {
      Header: "Điểm B",
      accessor: (item) => item?.toLocationName,
    },
    {
      Header: "Đơn giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.unitPrice}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "KL Hàng(kg)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item?.finalMerchandiseWeight}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />,
    },
    {
      Header: "Doanh thu(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.totalAmount}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Tiền tài(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.driverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tiền tài phụ(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.subDriverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Trạng thái",
      accessor: (item) => item?.statusName,
    },
    {
      Header: "Ngày tạo",
      accessor: (item) => item.createdAt
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();

                        history.push(`/pn/bill/${item.id}`);
                      }}
                    >
                      <Icon
                        name={"edit"}
                      ></Icon>
                      <span>
                        Cập nhật
                      </span>
                    </DropdownItem>
                  </li>


                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        history.push(`/pn/bill/create?duplicateId=${item.id}`);
                      }}
                    >
                      <Icon
                        name={"copy"}
                      ></Icon>
                      <span>
                        Nhân bản
                      </span>
                    </DropdownItem>
                  </li>
                  {item.status === "APPROVED" ? (
                    <></>
                  ) : (
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#dropdown"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setDeleteItem({
                            id: item.id,
                          });
                          toggle("isDelete");
                        }}
                      >
                        <Icon name="trash" className="text-danger"></Icon>
                        <span>Xoá</span>
                      </DropdownItem>
                    </li>
                  )}
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = queryString.stringify({
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.customerDirection ? { customerDirection: filter.customerDirection } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.ingredientId?.length > 0 ? { ingredientId: filter.ingredientId } : {}),
      ...(filter.status ? { status: filter.status } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.driverId ? { driverId: filter.driverId } : {}),
      ...(filter.fromLocation ? { fromLocation: filter.fromLocation } : {}),
      ...(filter.toLocation ? { toLocation: filter.toLocation } : {}),
      ...(filter.location ? { location: filter.location } : {}),
      ...(filter.note ? { note: filter.note } : {}),
    }, { arrayFormat: 'bracket' });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    getData();
  }, [timeNow, filter]);

  const getData = () => {
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = queryString.stringify({
        fromDate: moment(rangeDate.fromDate).toDate(),
        toDate: moment(rangeDate.toDate).toDate(),
        ...(filter.customerId ? { customerId: filter.customerId } : {}),
        ...(filter.customerDirection ? { customerDirection: filter.customerDirection } : {}),
        ...(filter.type ? { type: filter.type } : {}),
        ...(filter.ingredientId?.length > 0 ? { ingredientId: filter.ingredientId } : { ingredientGroup: [INGREDIENT_GROUP.INGREDIENT] }),
        ...(filter.status ? { status: filter.status } : {}),
        ...(filter.truckId ? { truckId: filter.truckId } : {}),
        ...(filter.driverId ? { driverId: filter.driverId } : {}),
        ...(filter.fromLocation ? { fromLocation: filter.fromLocation } : {}),
        ...(filter.toLocation ? { toLocation: filter.toLocation } : {}),
        ...(filter.location ? { location: filter.location } : {}),
        ...(filter.note ? { note: filter.note } : {}),
      }, { arrayFormat: 'bracket' });

      GET(`/pn-bill?${params.toString()}`, {}, true)
        .then(({ data }) => {
          const rows = data?.rows || [];
          setData([...rows]);
          setSummary({
            ...data.summary,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  };

  useEffect(() => {

    GET(
      "truck", {}, true
    ).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });


    GET("/location-distance", {}, true)
      .then((resp) => {
        const { data } = resp;
        const fromObj = {};
        const toObj = {};
        data.forEach((c) => {
          fromObj[c.fromLocation] = {
            fromLocation: c.fromLocation,
            fromLocationName: c.fromLocationName || c.fromLocation,
          };
          toObj[c.toLocation] = {
            toLocation: c.toLocation,
            toLocationName: c.toLocationName || c.toLocation,
          };
        });
        setFromLocationOptions(Object.values(fromObj).map((c) => ({
          label: c.fromLocationName,
          value: c.fromLocation,
          data: c,
        })));
        setToLocationOptions(Object.values(toObj).map((c) => ({
          label: c.toLocationName,
          value: c.toLocation,
          data: c,
        })));
      })

    GET("/user/list-drivers", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setDriverOptions(
          data.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET("/pn-customer", {}, true).then((resp) => {
      setCustomerOptions(
        resp.data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  // function to close the form modal
  const onFormCancel = () => {
    setView({ isDelete: false, addReport: false });
  };

  const deleteOrder = ({ id }) => {
    if (!id) {
      return;
    }
    DELETE(`pn-bill/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa đơn thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const onRangeChange = (dates) => {
    const [fromDate, toDate] = dates;
    setRangeDate({
      fromDate: fromDate ? moment(fromDate)?.startOf('days').toDate() : fromDate,
      toDate: toDate ? moment(toDate)?.endOf('days').toDate() : toDate
    });
    if (fromDate && toDate) {
      setTimeNow(moment().valueOf());
    }
  };


  const exportExcel = () => {
    const params = queryString.stringify({
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.customerDirection ? { customerDirection: filter.customerDirection } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.ingredientId?.length > 0 ? { ingredientId: filter.ingredientId } : { ingredientGroup: [INGREDIENT_GROUP.INGREDIENT] }),
      ...(filter.status ? { status: filter.status } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.driverId ? { driverId: filter.driverId } : {}),
      ...(filter.fromLocation ? { fromLocation: filter.fromLocation } : {}),
      ...(filter.toLocation ? { toLocation: filter.toLocation } : {}),
      ...(filter.location ? { location: filter.location } : {}),
      ...(filter.note ? { note: filter.note } : {}),
      token: getToken(),
    }, { arrayFormat: 'bracket' })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn-bill/get-bill-excel/bill?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Quản lý đơn hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <RSelect
                          isClearable
                          placeholder="Điểm đi"
                          options={fromLocationOptions}
                          value={
                            fromLocationOptions.find(
                              (c) => c.value === filter.fromLocation
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              fromLocation: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <RSelect
                          isClearable
                          placeholder="Điểm đến"
                          options={toLocationOptions}
                          value={
                            toLocationOptions.find(
                              (c) => c.value === filter.toLocation
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              toLocation: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          classNamePrefix="form-control"
                          placeholder="Lọc theo xe"
                          options={truckOptions}
                          value={truckOptions.find(
                            (c) => c.value === filter.truckId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              truckId: val?.value || undefined
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 180 }}>
                        <RSelect
                          isClearable
                          classNamePrefix="form-control"
                          placeholder="Lọc theo tài xế"
                          options={driverOptions}
                          value={driverOptions.find(
                            (c) => +c.value === +filter.driverId
                          ) || ""}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              driverId: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <Input type="text" placeholder="Lọc theo ghi chú" value={filter.note} onChange={(e) => setFilter({ ...filter, note: e.target.value })} />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Khách hàng/Nhà cung cấp"
                          options={customerOptions}
                          value={
                            customerOptions.find(
                              (c) => c.value == filter.customerId
                            ) || ""
                          }
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder='N/X HH'
                          options={BILL_TYPE_OPTIONS}
                          value={BILL_TYPE_OPTIONS.find((c) => c.value === filter.customerDirection)}
                          onChange={(val) => setFilter({
                            ...filter,
                            customerDirection: val?.value || undefined,
                          })}
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder='Loại'
                          options={BILL_TYPE_OPTIONS}
                          value={BILL_TYPE_OPTIONS.find((c) => c.value === filter.type)}
                          onChange={(val) => setFilter({
                            ...filter,
                            type: val?.value || undefined,
                          })}
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder='Trạng thái'
                          options={BILL_STATUS_OPTIONS}
                          value={BILL_STATUS_OPTIONS.find((c) => c.value === filter.status)}
                          onChange={(val) => setFilter({
                            ...filter,
                            status: val?.value || undefined,
                          })}
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder='Địa điểm'
                          options={LOCATION_OPTIONS}
                          value={LOCATION_OPTIONS.find((c) => c.value === filter.location) || null}
                          onChange={(val) => setFilter({
                            ...filter,
                            location: val?.value || undefined,
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.fromDate}
                          startDate={rangeDate.fromDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.toDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.push("/pn/bill/create");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                    {selectedBillIds.length > 0 && (
                      <li>
                        <div>
                          <Button
                            color="info"
                            onClick={() => setShowModalVAT(true)}
                          >
                            <span>Tạo VAT ({selectedBillIds.length})</span>
                          </Button>
                        </div>
                      </li>
                    )}

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    notShowPagi
                    loading={loading}
                    columns={colTable}
                    data={data}
                    headerRow={(
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td colSpan={12} className="nk-tb-col">
                          <span> Tổng kết ({summary.totalCount || 0} đơn) </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary?.finalMerchandiseWeight || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>

                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary?.totalAmount || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá đơn hàng này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteItem);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {showModalVAT && (
          <ModalPnBillVAT
            amount={data
              .filter(item => selectedBillIds.includes(item.id))
              .reduce((sum, item) => sum + (item.totalAmount || 0), 0)}
            selectedBillIds={selectedBillIds}
            onCancel={() => setShowModalVAT(false)}
            onSuccess={() => {
              setShowModalVAT(false);
              setSelectedBillIds([]);
              resetData();
            }}
          />
        )}

      </Content>
    </React.Fragment>
  );
};

export default PnBillManager;
